// Mock data for Inventive Apps Ltd website

export const companyInfo = {
  name: "Inventive Apps LTD",
  tagline: "Business Management Software Solutions",
  registeredNumber: "17034053",
  registeredAddress: "81 Lambeth Rd, L4 1SH, Liverpool, United Kingdom",
  email: "contact@inventiveapps.tech",
  
  introduction: {
    title: "Welcome to Inventive Apps",
    description: "We are a UK-based software company dedicated to creating practical, efficient business management solutions for small businesses and self-employed professionals."
  },
  
  whatWeDo: {
    title: "What We Do",
    description: "We develop mobile and web applications that simplify business operations.",
    services: [
      {
        id: 1,
        title: "Booking Management",
        description: "Streamlined booking systems that help you manage appointments and reservations efficiently.",
        icon: "calendar"
      },
      {
        id: 2,
        title: "Cancellation Handling",
        description: "Smart cancellation management tools that reduce no-shows and improve customer communication.",
        icon: "x-circle"
      },
      {
        id: 3,
        title: "Scheduling Solutions",
        description: "Intelligent scheduling features that optimize your time and resources.",
        icon: "clock"
      },
      {
        id: 4,
        title: "Customer Communication",
        description: "Integrated communication tools to keep you connected with your customers.",
        icon: "message-square"
      }
    ]
  },
  
  whoItsFor: {
    title: "Who the Software Is For",
    description: "Our solutions are designed specifically for:",
    targetAudience: [
      {
        id: 1,
        title: "Small Businesses",
        description: "Growing companies that need efficient tools to manage customer bookings and scheduling.",
        icon: "building-2"
      },
      {
        id: 2,
        title: "Self-Employed Professionals",
        description: "Independent consultants, therapists, trainers, and service providers managing their own schedules.",
        icon: "user"
      },
      {
        id: 3,
        title: "Service Providers",
        description: "Businesses offering appointment-based services who need reliable scheduling systems.",
        icon: "briefcase"
      }
    ]
  },
  
  currentStatus: {
    title: "Current Status",
    description: "We are currently in the development phase, building robust and user-friendly applications.",
    statusItems: [
      {
        id: 1,
        title: "Product Development",
        description: "Our team is actively developing mobile and web applications with a focus on reliability and ease of use.",
        icon: "code"
      },
      {
        id: 2,
        title: "Testing Phase",
        description: "We are conducting thorough testing to ensure our solutions meet the highest quality standards.",
        icon: "check-circle"
      },
      {
        id: 3,
        title: "Launch Preparation",
        description: "Preparing for launch with a commitment to delivering valuable tools for our target users.",
        icon: "rocket"
      }
    ]
  },
  
  navigation: [
    { id: "about", label: "About" },
    { id: "what-we-do", label: "What We Do" },
    { id: "who-its-for", label: "Who It's For" },
    { id: "status", label: "Current Status" },
    { id: "contact", label: "Contact" }
  ]
};
